import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from "@material-ui/core/MenuItem";
import {_isAdmin} from "../../helpers/functions";

const SortScoreRecordsForm =  (props) => {
  return (
    <form>
      <div className={'form-row'}>
        <div className={'form-group col-7'}>
          <Field name="sortBy" label={'Sort By'} component={RenderSelectField} fullWidth>
            <MenuItem value={'id'} >{'Id'}</MenuItem>
            <MenuItem value={'type'} >{'Type'}</MenuItem>
            <MenuItem value={'createdDate'} >{'Created Date'}</MenuItem>
            {_isAdmin(props.personRoles) && (
              <MenuItem value={'email'} >{'Person Email'}</MenuItem>
            )}
            {_isAdmin(props.personRoles) && (
              <MenuItem value={'department'} >{'Department'}</MenuItem>
            )}
          </Field>
        </div>
        <div className={'form-group col-5'}>
          <Field name={'sortOrder'} label={'Sort Order'} component={RenderSelectField} fullWidth>
            <MenuItem value={'asc'}>{'ASC'}</MenuItem>
            <MenuItem value={'desc'}>{'DESC'}</MenuItem>
          </Field>
        </div>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'sortScoreRecordsForm',
})(SortScoreRecordsForm);



// WEBPACK FOOTER //
// ./src/components/scoreRecords/sortScoreRecordsForm.js